
let _ = require('../_.js');
let $ = jQuery;

import './auctionui-bids.js';
import './auctionui-data.js';
import './auctionui-gallery.js';
import './auctionui-general-ui.js';
import './auctionui-login.js';
import './auctionui-signup.js';
import './auctionui-tracks.js';
import './auctionui-main.js';
import './auctionui-registration.js';
import './auctionui-chat.js';
import './auctionui-bidhistory.js';
import './auctionui-router.js';
import './auctionui-agents.js';
import './auctionui-item-details.js';
import './auctionui-summary.js';
import './auctionui-nouns.js';
import './auctionui-sealed-bid.js';
import './auctionui-countdown.js';
import './page-index.js';
import './page-lots.js';

_.ac_state = { "flags": {} };

let _auction_current_round_id_cache = null;
let _auction_round_subscription = null;
let _auction_item_subscription = null;
let _has_done_auctionui_init_session_updates = false;

_.AuctionUI = class AuctionUI {

    static that;
    static __on_update_auction_items_callbacks = [];

    // Probably obsolete.  was originally designed to get auction_id before init completes.
    static auction_id() {
        if (_.ac_state.auction) {
            return _.ac_state.auction.id;
        } else {
            return null;
        }
    }

    static property_id() {
        if (!_.ac_state._property_id) {
            if ($("#auctioncast-property_id").length) {
                _.ac_state._property_id = parseInt($("#auctioncast-property_id").attr('data-property_id'));
            }
        }

        return _.ac_state._property_id;
    }

    // The following code is all about loading elements on a listings / auctions view page.
    // If we are not on that page, one of these if statements will break us out of the function.
    static async init() {
        let that = this;

        console.log("AuctionUI Init");

        let property_id = _.AuctionUI.property_id();

        if (!property_id) {
            console.warn("Property ID is not set, not loading property view functionality");
            return;
        }

        // Check and warn on older safari
        _.warnUnsupportedBrowser();

        let property = await App_Models_Property.fetch(property_id);

        console.log(property_id);
        console.log(property);

        if (!property) {
            _.flash_alert("Error loading property data");
            console.warn("Property not found, bailing on property functionality");
            return;
        }

        _.ac_state.property = property;

        let propertyable = await property.propertyable.fetch();

        if (!propertyable) {
            _.flash_alert("Error loading property data");
            console.warn("Property not found, bailing on property functionality");
            return;
        }

        if (typeof propertyable.auction_status != 'undefined') {
            _.ac_state.auction = propertyable;
        } else {
            _.ac_state.listing = propertyable;
        }

        _.Modal.clone();

        $("body").prepend($('#lp-modal-overlay'));
        $("body").prepend($('#modal-clone'));

        // disabled for now enable_ac=false
        // return;

        // Error: loading on legacy auctions

        // Refresh the layout handler since some state has changed.
        await _.landproz_layout_handler();

        console.log("Auctioncast auction handler script started for auction id " + _.AuctionUI.auction_id());

        await _.AuctionUI_Agents.init();

        // Initiate all auction related modules

        if (_.ac_state.auction) {
            await _.AuctionUI._init_auctions_non_interactive();
        }

        if (_.ac_state.auction && _.ac_state.auction.is_online_auction) {
            await _.AuctionUI._init_auctions_interactive();
        }

        await _.auctionui_gallery_module_init();
    }


    static async _init_auctions_non_interactive() {
        _.on_ui_update_once(".auction_manager_contact_fragment", function () {
            $(this).html(_.ac_state.auction.getContactHtmlFragment);
        })
    }

    static async _init_auctions_interactive() {

        $("#landproz-auctioncast-auction").show();
        $("#landproz-auctioncast-auction-bidding").show();

        // Get initial data.  Do not load any other modules until we have initial data.
        await _.AuctionUI_Data.init();

        console.log("Initial auction data: ", _.ac_state.auction);

        if (!_.ac_state.auction.is_online_auction) {
            console.log("Not an online auction, ending further auction hooks.");
            _.AuctionUI._hide_main_preloader();
            return;
        }

        // Init time manager.  Would be nice if this was more global rather than auction ui scoped.
        _.time = new _.TimeManager(_.ac_state.auction.current_time_localized);

        await _.AuctionUI_Data.init();

        // _.ac_state.auction is now loaded.

        // Final state init
        if (_.AuctionUI.auction_is_choice()) {
            console.log("Setting choice initial state");

            await _.AuctionUI.set_current_round(_.ac_state.auction.current_round_id);
            await _.AuctionUI._track_choice_round();
        }

        _.auctionui_replace_custom_nouns();
        if (_.AuctionUI.auction_is_enterprise()) {
            await _.auctionui_replace_whole_farm_nouns();
            _.AuctionUI_Data.on_data_update("auction.auction_items", () => _.auctionui_replace_whole_farm_nouns());
        }

        await _.AuctionUI_Chat.init();
        await _.AuctionUI_Auction_Registration.init();
        await _.AuctionUI_Tracks.init();
        await _.AuctionUI_Main.init();
        await _.AuctionUI_Login.init();
        await _.AuctionUI_Signup.init();
        await _.AuctionUI_Auction_General_UI.init();
        await _.AuctionUI._ui_hooks();
        await _.AuctionUI_Bids.init();
        await _.AuctionUI_BidHistory.init();
        await _.AuctionUI_Router.init();
        await _.AuctionUI_Sealed_Bid.init();
        await _.AuctionUI_Countdown.init();
        await _.Page_Index.init();
        await _.Page_Lots.init();   // obsolete?

        // Session check
        await _.AuctionUI._init_session_updates();
        await _.Notification_Force_Accept_Site_Terms.init();

        // All good. 
        await _.AuctionUI_Router.on_ready();
        await this.init_btn_toolbar_fix_items_per_row_2x2();
        await _.auctionui_summary_init();
        _.AuctionUI._hide_main_preloader();
        _.AuctionUI._hide_main_preloader();
    }

    // Can be called more than once, should only run once
    static _init_session_updates() {
        if (_has_done_auctionui_init_session_updates) {
            return;
        }

        _has_done_auctionui_init_session_updates = true;

        _.AuctionUI_Session.session_updated_handler(async function (data) {
            await _.AuctionUI_Login.session_updated_handler();
            await _.AuctionUI_Bids.session_updated_handler();
            await _.AuctionUI_Sealed_Bid.session_updated_handler();
            await _.AuctionUI_Chat.session_updated_handler();
            await _.Lib_Notifications.session_updated_handler();
        });
    }

    static _hide_main_preloader() {
        $(".landproz-ace-loaded").show();
        $(".landproz-ace-loading").hide();
    }

    // On choice auction, watches if the current round changes on the auction and updates the ui accordingly.
    // Assumes that the auction is choice if called, that validation happens elsewhere.
    static _track_choice_round() {
        // await _.AuctionUI.set_current_round(_.ac_state.auction.current_round_id);
        _auction_current_round_id_cache = _.ac_state.auction.current_round_id;
        _.ac_state.auction.subscribe(true, async function (data) {
            console.log("Auction updated ", data);
            let should_change_round = false;
            if (data.current_round_id != _auction_current_round_id_cache) {
                // if (_.ac_state.current_round_id != _auction_current_round_id_cache) {
                should_change_round = true;
                // }
            }
            if (should_change_round) {
                _auction_current_round_id_cache = data.current_round_id;
                _.AuctionUI.set_current_round(data.current_round_id);
                let current_item = await _.AuctionUI.get_current_item();
                if (!current_item || current_item.status != App_Models_AuctionItem.STATUS_AVAILABLE) {
                    let found_unsold_item = false;
                    let items = await _.ac_state.auction.auction_items.fetch();
                    items.forEach(function (item, index) {
                        if (item.status == App_Models_AuctionItem.STATUS_AVAILABLE && found_unsold_item == false) {
                            found_unsold_item = true;
                            console.log(item);
                            _.AuctionUI.set_current_item(item.id);
                        }
                    });
                    console.log(found_unsold_item);

                }
            }
        });
    };

    // Really quick rules for some classes.
    // probably should go somewhere else.
    static _ui_hooks() {
        // ac-widget-name-current-auction gets filled in with current auction name
        _.on_ui_update_once(".ac-widget-name-current-auction", function () {
            let $e = $(this);
            _.AuctionUI_Data.on_data_update("auction.property.title", function (title) {
                try {
                    $e.text(title);
                } catch (e) {
                    _.shouldnt_happen();
                    $e.text("----");
                }
            });
        });

        _.on_ui_update_once(".per-acre-box-shared", function () {
            if (!_.AuctionUI.auction_is_choice()) {
                $(this).addClass('per-acre-box-shared-minheight');
            }
        });
    }

    // Returns the currently selected item
    static async get_current_item() {
        try {
            if (_.ac_state.current_item_id) {
                let current_item = await App_Models_AuctionItem.get(_.ac_state.current_item_id);
                if (current_item && current_item.auction_id == _.ac_state.auction.id) {
                    return current_item;
                }
            }
            return null;
        } catch (e) {
            return null;
        }
    }

    // Returns the current round of the auction in choice, or the round associated to the selected item in 
    static async get_current_round() {
        try {
            if (_.ac_state.current_round_id) {
                let current_round = await _.ac_state.auction.auction_rounds.find(_.ac_state.current_round_id);

                if (current_round && current_round.auction_id == _.ac_state.auction.id) {
                    return current_round;
                }
            }

            return null;
        } catch (e) {
            console.warn(e);
            return null;
        }
    }

    // Sets the current auction item, updates gui and data
    static async set_current_round(round_id) {
        let that = this;

        console.warn("Setting round index ", round_id);

        try {
            _.ac_state.current_round_id = round_id;

            // UI Updates
            if (that.__on_update_auction_items_handler) {
                await that.__on_update_auction_items_handler();
            }

            if (_.AuctionUI_Bids._update_bidding_ui) {
                await _.AuctionUI_Bids._update_bidding_ui();
            }

            if (_auction_round_subscription && _auction_round_subscription.unsubscribe) {
                try {
                    await _auction_round_subscription.unsubscribe();
                } catch (e) {

                }
            }

            let auction_round = await that.get_current_round();
            _auction_round_subscription = auction_round.subscribe(true, _.AuctionUI_Bids._update_bidding_ui);

        } catch (e) {
            console.error(e);
            _.shouldnt_happen();
        }
    }


    // Sets the current auction item, updates gui and data
    static async set_current_item(item_id) {
        let that = this;

        try {
            console.warn("Setting item id ", item_id);

            _.ac_state.current_item_id = item_id;
            let item = await this.get_current_item();
            if (!item) {
                _.shouldnt_happen();
                return;
            }

            if (_.AuctionUI.auction_is_standard_or_enterprise() || _.AuctionUI.auction_is_sealed_bid()) {
                if (!item.auction_round_id) {
                    _.shouldnt_happen();
                } else {
                    _.AuctionUI.set_current_round(item.auction_round_id);
                }
            } else if (item.status == App_Models_AuctionItem.STATUS_SOLD && item.auction_round_id) {
                _.AuctionUI.set_current_round(item.auction_round_id);
            } else if (_.AuctionUI.auction_is_choice()) {
                _.AuctionUI.set_current_round(_.ac_state.auction.current_round_id);
            }

            // Some special logic here:
            // Position all "$(".ac-component-bid")" elements to the right of the tracks element
            // start an animation where the tracks go to the left and all elements fly in from the right
            // All we need to do is supress hiding tracks then.

            let items = await _.ac_state.auction.auction_items.fetch();
            if (items.length != 1) {
                _.AuctionUI_Router.update_history(item_id ? 'item-' + item_id : '');
            }

            // UI Updates
            if (that.__on_update_auction_items_handler) {
                await that.__on_update_auction_items_handler();
            }

            if (_.AuctionUI_Bids._update_bidding_ui) {
                await _.AuctionUI_Bids._update_bidding_ui();
            }

            if (_auction_item_subscription && _auction_item_subscription.unsubscribe) {
                try {
                    await _auction_item_subscription.unsubscribe();
                } catch (e) {

                }
            }

            let auction_item = await that.get_current_item();

            if (auction_item) {
                _auction_item_subscription = auction_item.subscribe(true, _.AuctionUI_Bids._update_bidding_ui);
            }

        } catch (e) {
            console.error(e);
            _.shouldnt_happen();
        }
    }

    static async on_update_auction_items(callback) {
        let that = this;

        if (!that.__on_update_auction_items_handler) {

            // Creates a callback executor function if it isn't already defined.
            // This will get called when the current item changes, or any items properties are updated.
            that.__on_update_auction_items_handler = async function () {

                let items = await _.ac_state.auction.auction_items.fetch();

                for (let i = 0; i < that.__on_update_auction_items_callbacks.length; i++) {
                    that.__on_update_auction_items_callbacks[i](items);
                }
            }

            _.AuctionUI_Data.on_data_update("auction.auction_items", that.__on_update_auction_items_handler);
        }

        that.__on_update_auction_items_callbacks.push(callback);

        callback(await _.ac_state.auction.auction_items.fetch());
    }

    static auction_is_standard() {
        return _.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_STANDARD;
    }

    static auction_is_choice() {
        return _.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_CHOICE;
    }

    static auction_is_standard_or_enterprise() {
        return _.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_STANDARD ||
            _.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_ENTERPRISE;
    }

    static auction_is_sealed_bid() {
        return _.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_SEALED_BID;
    }

    static auction_is_enterprise() {
        return _.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_ENTERPRISE;
    }

    static async fees_string_v2_single_line_acres(price, acres) {
        let auction = _.ac_state.auction;

        let fees = auction.total_fees;
        if (!fees) fees = 0;

        return "<strong>" + _.currency(price) + "</strong> x " + acres +
            _.property_noun_unit_abbr_plusminus() +
            (
                !auction.is_import && fees == 0 ? " + " + _.percentage(fees) + " fees" : ""
            ) + " =  <strong>" + _.currency(price * acres * (1 + (fees / 100))) + "</strong>";
        // !auction.is_import && fees == 0 ? _.currency(price * acres) + " + " + _.percentage(fees) + " fees = " : ""
    }

    static async fees_string_v2_single_line_flat(price) {
        let auction = _.ac_state.auction;

        let fees = auction.total_fees;
        if (!fees) fees = 0;

        return "<strong>" + _.currency(price) + "</strong>" + (
            !(auction.is_import && fees == 0) ? " + " + _.percentage(fees) + " fees = " +
                "<strong>" + _.currency(price * (1 + (fees / 100))) + "</strong>"
                : "");
    }

    static async fees_string_v2_multi_line_acres(price, acres) {
        let auction = _.ac_state.auction;

        let fees = auction.total_fees;
        if (!fees) fees = 0;

        if (!(auction.is_import && fees == 0)) {
            return "<div><strong>" + _.currency(price) + "</strong> x " + acres + " " +
                _.property_noun_unit_abbr_plusminus() + " =</div>" +
                "<div style='margin: auto;display: table; padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;'>" +
                _.currency(price * acres) + " + " + _.percentage(fees) + " fees " + " = </div>" +
                "<div><strong>" + _.currency(price * acres * (1 + (fees / 100))) + "</strong></div>";
        } else {
            return "<div style='margin: auto;display: table; padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;'><strong>" + _.currency(price) + "</strong> x " + acres + " " +
                _.property_noun_unit_abbr_plusminus() + " =</div>" +
                "<div><strong>" + _.currency(price * acres * (1 + (fees / 100))) + "</strong></div>";
        }

    }

    static async fees_string_v2_multi_line_flat(price) {
        let auction = _.ac_state.auction;

        let fees = auction.total_fees;
        if (!fees) fees = 0;

        if (!(auction.is_import && fees == 0)) {
            return "<div style='margin: auto;display: table; padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;'>" +
                "<strong>" + _.currency(price) + "</strong> + " + _.percentage(fees) + " fees "
                + " = " + "</div><div><strong>" + _.currency(price * (1 + (fees / 100))) + "</strong></div>";
        } else {
            return "<div><strong>" + _.currency(price * (1 + (fees / 100))) + "</strong></div>";
        }
    }

    // Generates html.
    // Pass in optional value round to get the price for a specific round if choice.  Leave undefined
    // in most cases.
    static async fees_string_v2_single_line_item(item, round) {
        if (!round) {
            if (_.AuctionUI.auction_is_choice() && item.status != App_Models_AuctionItem.STATUS_SOLD) {
                return '';
            }

            round = await item.auction_round.fetch();
            if (!round) {
                return '';
            }
        }

        // This is a kludge to deal with a broken db state, it would never happen unless you delete a bunch of records
        // after making a sale. (perhaps happens when reassigning an item after sale or something? idk)
        if (round.status == App_Models_AuctionRound.STATUS_SOLD && !item.sale_price) {
            return "";
        }

        let amount = round.current_price;

        if (_.ac_state.auction.auction_format == App_Models_Auction.AUCTION_FORMAT_SEALED_BID) {
            let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(round);

            if (best_bid_by_user) {
                amount = best_bid_by_user.amount;
            } else {
                return "";
            }
        }

        if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
            return await _.AuctionUI.fees_string_v2_single_line_acres(amount, item.acres);
        } else {
            return await _.AuctionUI.fees_string_v2_single_line_flat(amount, item.acres);
        }
    }

    static async fees_string_v2_multi_line_item(item, round) {
        if (!round) {
            if (_.AuctionUI.auction_is_choice() && item.status != App_Models_AuctionItem.STATUS_SOLD) {
                return '';
            }

            round = await item.auction_round.fetch();

            if (!round) {
                return '';
            }
        }

        // This is a kludge to deal with a broken db state, it would never happen unless you delete a bunch of records
        // after making a sale. (perhaps happens when reassigning an item after sale or something? idk)
        if (round.status == App_Models_AuctionRound.STATUS_SOLD && !item.sale_price) {
            return "";
        }

        if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
            return await _.AuctionUI.fees_string_v2_multi_line_acres(round.current_price, item.acres);
        } else {
            return await _.AuctionUI.fees_string_v2_multi_line_flat(round.current_price, item.acres);
        }
    }

    // Makes buttons consistent width if more than one row of btn-toolbar buttons
    static init_btn_toolbar_fix_items_per_row_2x2() {
        _.on_ui_update_once('.btn-toolbar', function () {

            let $toolbar = $(this);

            let evaluateAndModify = _.debounce(50, async function () {
                // Cache check: Exit function early if conditions haven't changed
                let visibleChildren = $toolbar.children(':visible').not("br");
                let currentVisibleCount = visibleChildren.length;
                let currentDimensions = { width: $toolbar.width(), height: $toolbar.height() };
                let currentTexts = visibleChildren.map(function () { return $(this).text(); }).get().join("|");

                // Check if conditions have changed using cached data
                if ($toolbar.data('lastVisibleCount') === currentVisibleCount &&
                    $toolbar.data('lastDimensions') && $toolbar.data('lastDimensions').width === currentDimensions.width &&
                    $toolbar.data('lastDimensions').height === currentDimensions.height &&
                    $toolbar.data('lastTexts') === currentTexts) {
                    return; // Exit if no changes in count, dimensions, or text content
                }

                // Update cache with new data
                $toolbar.data('lastVisibleCount', currentVisibleCount);
                $toolbar.data('lastTexts', currentTexts);

                // Reset widths to ensure clean calculation
                $toolbar.children().css('transition', 'none');
                $toolbar.children().css('min-width', '125px'); // Same as CSS
                $toolbar.children().css('width', '');
                $toolbar.children().css('max-width', '');


                let firstChildHeight = visibleChildren.first().outerHeight(true);  // Get the height of the first element
                if (!firstChildHeight) {
                    return;
                }

                let totalHeight = $toolbar.outerHeight() + 10;
                let numberOfRows = Math.floor(totalHeight / firstChildHeight);  // Determine the number of rows

                // Apply width settings based on the number of rows
                if (numberOfRows == 1) {
                    // If there's only one row, remove all min-width properties
                    // This was done at reset, so nothing to do.
                } else {
                    // For more than one row, calculate the max width and apply as min-width to all elements
                    let maxWidth = 0;
                    visibleChildren.each(function () {
                        maxWidth = Math.max(maxWidth, $(this).outerWidth());  // Find the largest width
                    });

                    $toolbar.children().css('min-width', maxWidth + 'px');  // Set the largest width as min-width for uniformity
                }

                // If this is a 2 row set of 4 buttons, force 4x4 grid
                if (visibleChildren.length == 4 && numberOfRows == 2) {
                    // For exactly 4 elements on two rows, show a 2x2 grid (avoid 3 buttons row 1, 1 button row 2)
                    $toolbar.children().css('width', '35%');
                    $toolbar.children().css('max-width', '300px');
                }

                let newDimensions = { width: $toolbar.width(), height: $toolbar.height() };

                await _.sleep(50);

                $toolbar.data('lastDimensions', newDimensions);
            });

            evaluateAndModify();  // Initial call
            $(window).resize(evaluateAndModify);  // Re-evaluate on every window resize

            evaluateAndModify();  // Initial call on document ready.

            setInterval(evaluateAndModify, 1500);
        });
    }


}
